import React, { useEffect, useState, useRef, useMemo } from "react"
import { withRouter } from "react-router-dom"
import { Card, CardBody, Col, Row, Button } from "reactstrap"
import Select from "react-select"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { messageTitle } from "constants/common"
import { getOccupancyRate as onGetOccupancyRate,
        getExportOccupancyRate as onGetExportOccupancyRate,      
        resetExportFileData, 
      } from "../../store/carpark/actions"
import { getSettingData } from "../../store/settings/actions"
import { isEmpty } from "lodash"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

//redux
import { useSelector, useDispatch } from "react-redux"
import moment from "moment"

const sizePerPage = 25;
const defaultStartDate = moment().startOf("M")
const defaultEndDate = moment()
import { dateformat } from "config"


const OccupancyRate = props => {
  const dispatch = useDispatch()
  const [fileType, setFileType] = useState({ label: "PDF", value: "pdf" });
  const [filterCarpark, setFilterCarpark] = useState({
    value: "All",
    label: "All Car Park",
  })

  const [filters, setFilters] = useState({
    startDate: defaultStartDate.format(dateformat.default),
    endDate: defaultEndDate.format(dateformat.default),})

  const [startDate, setStartDate] = useState(
    defaultStartDate.format(dateformat.default)
  )
  const [endDate, setEndDate] = useState(
    defaultEndDate.format(dateformat.default)
  )

  const {
    occupancyRate, file, message, pagination, settingData, error,
  } = useSelector(state => ({
    occupancyRate: state.carPark.occupancyRate,
    pagination: state.carPark.occupancyRatePagination,
    message: state.carPark.message,
    error: state.carPark.error,
    settingData: state.Settings.settingData,
    file: state.carPark.file,
  }))
  const [currentPage, setCurrentPage] = useState(1);
  const [primaryStations, setPrimaryStations] = useState([]);


  useEffect(() => {
    dispatch(onGetOccupancyRate({ ...filters, page: currentPage, size: sizePerPage }))
  }, [currentPage]);



  const defaultSorted = [
    {
      dataField: "hour", // if dataField is not match to any column you defined, it will be ignored.
      order: "desc", // desc or asc
    },
  ]

  const occupancyColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true
    },
    {
      text: "Carpark",
      dataField: "carpark",
      sort: true,
    },
    {
      text: "Date",
      dataField: "date",
      sort: true,
      formatter: (cellContent, occupancy) => <>{moment(occupancy.date).format("DD-MM-YYYY")}</>,
    },
    {
      text: "Time",
      dataField: "hour",
      sort: true,
    },
    {
      text: "Day of the Week",
      dataField: "day",
      sort: true,
    },
    {
      text: "Max Lots Occupied",
      dataField: "maxLots",
      sort: true,
    }
  ]

  useEffect(() => {
    dispatch(getSettingData());
  }, []);

  useEffect(() => {
    if (settingData?.pmsIntegration?.carparkSettings) {
      const list = (settingData?.pmsIntegration?.carparkSettings || []).filter(
        e => !_.isEmpty(e?.code) && !_.isEmpty(e?.url)
      ).map(el => {
        return {
          value: `${el?.code}`,
          label: `${el?.title}`,
        }
      })
      setPrimaryStations([...list,{value: "All", label: "All Car Park",}])
    }
  }, [settingData]);

  useEffect(() => {
    if (file) {
      handleExport(file)
      setTimeout(() => {
        dispatch(resetExportFileData())
      }, 300)
    }
  }, [file]);


  useEffect(() => {
    if (!isEmpty(error)) {
      //setLoading(false)
      toastr.error(error.message, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, error])

  useEffect(() => {
    if (!isEmpty(occupancyRate)) {
      //setLoading(false)
    } else {
      setTimeout(() => {
       // setLoading(false)
      }, 1000)
    }
  }, [occupancyRate])

  var node = useRef()

  const pageOptions = {
    page: currentPage,
    sizePerPage: sizePerPage,
    totalSize: pagination ? pagination?.totalItems : 1,
    totalPages: pagination ? pagination?.totalPages : 1,
    custom: true,
    onPageChange: setCurrentPage,
  }

  const handleCarparkFilter = e => {
    setFilterCarpark(e);
    setCurrentPage(1);
    dispatch(onGetOccupancyRate({ ...filters, carpark: e.value, page: currentPage, size: sizePerPage }))
    setFilters({ ...filters, carpark: e.value })
  }

  const handleTableChange = () => {

  }

  const handleStartDateSearch = value => {

    setCurrentPage(1);
    dispatch(onGetOccupancyRate({ ...filters, startDate: value, page: currentPage, size: sizePerPage }));
    setFilters({ ...filters, startDate: value });
    setStartDate(value);
  }

  const handleEndDateSearch = value => {
    setCurrentPage(1);
    dispatch(onGetOccupancyRate({ ...filters, endDate: value, page: currentPage, size: sizePerPage }))
    setFilters({ ...filters, endDate: value })
    setEndDate(value)
  }

  const handleReset = () => {
    
    setStartDate(defaultStartDate.format(dateformat.default))
    setEndDate(defaultEndDate.format(dateformat.default))
    setCurrentPage(1);
    dispatch(onGetOccupancyRate({ page: currentPage, size: sizePerPage,    
      startDate: defaultStartDate.format(dateformat.default),
      endDate: defaultEndDate.format(dateformat.default), })) // Set current page to first page
    setFilters({})
    setEndDate()
    setStartDate()
    setFilterCarpark({
      value: "All",
      label: "All Car Park",
    })
  }


  const setDownloadType = () => {
    dispatch(onGetExportOccupancyRate({ ...filters, file_type: fileType.value, }))
  }

  const handleExport = fileData => {
    const fileName =
      `occupancy_rate_` +
      new Date().getTime() +
      `.${fileType.value.toLowerCase()}`
    const downloadType =
      fileType.value == "csv" || fileType.value == "xlsx"
        ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        : "application/pdf"
    const base64data = `data:${downloadType};base64,${fileData}`
    const downloadLink = document.createElement("a")
    downloadLink.href = base64data
    downloadLink.download = fileName
    downloadLink.click()
    return fileName
  }

  const handleSelectType = e => {
    setFileType(e)
  }

  const fileTypeOptions = [
    {
      label: "PDF",
      value: "pdf",
    },
    {
      label: "CSV",
      value: "csv",
    },
    {
      label: "XLSX",
      value: "xlsx",
    },
  ]

  const keyField = "_id"

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }


  return (
    <React.Fragment>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField={keyField}
                columns={occupancyColumns}
                data={occupancyRate || []}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return (
                    <ToolkitProvider
                      keyField={keyField}
                      data={occupancyRate || []}
                      columns={occupancyColumns}
                      bootstrap4
                      search
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col sm="2">
                              <Select
                                placeholer={"Select carpark"}
                                name={"filterCarpark"}
                                value={filterCarpark}
                                onChange={e => {
                                  handleCarparkFilter(e)
                                }}
                                options={primaryStations}
                                classNamePrefix="select2-selection"
                              />
                            </Col>
                            <Col sm="2">
                              <input
                                className="form-control"
                                type="date"
                                value={startDate ? startDate : " "}
                                id="startDate"
                                name="startDate"
                                onChange={e =>
                                  handleStartDateSearch(e.target.value)
                                }
                                onBlur={e =>
                                  handleStartDateSearch(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm="2">
                              <input
                                className="form-control"
                                type="date"
                                value={endDate ? endDate : " "}
                                id="endDate"
                                name="endDate"
                                onChange={e =>
                                  handleEndDateSearch(e.target.value)
                                }
                                onBlur={e =>
                                  handleEndDateSearch(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm="1">
                              <Button
                                color="primary"
                                className="font-14 btn-block btn btn-primary"
                                onClick={handleReset}
                              >
                                Reset
                              </Button>
                            </Col>
                            <Col sm="3">
                              <div
                                className="text-sm-end"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <div style={{ width: 100 }} className="me-2">
                                  <Select
                                    placeholder={"Select Type"}
                                    name={"File Type"}
                                    value={fileType}
                                    onChange={e => {
                                      handleSelectType(e)
                                    }}
                                    options={fileTypeOptions}
                                    classNamePrefix="select2-selection me-2"
                                  />
                                </div>
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={setDownloadType}
                                >
                                  <i className="bx bx-upload me-1" />
                                  Export
                                </Button>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  remote
                                  keyField={keyField}
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  defaultSorted={defaultSorted}
                                  classes={"table align-middle table-nowrap table-hover"}
                                  bordered={false}
                                  striped={false}
                                  responsive
                                  ref={node}
                                  noDataIndication={emptyDataMessage}
                                  onTableChange={handleTableChange}
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  )
                }}
              </PaginationProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default withRouter(OccupancyRate)